export default ({ dispatch, getState }) => next => action => {
  if (typeof action.asyncAction === "function") {
    dispatch({ type: `${action.type}_PENDING` });
    return action
      .asyncAction(dispatch, getState)
      .then(res => {
        dispatch({ type: `${action.type}_SUCCESS`, res });

        if (res.code) {
          dispatch({ type: "ROUTING", data: { code: res.code, getState } });
        }
      })
      .catch((error = { code: "Unknown Error" }) => {
        dispatch({ type: `${action.type}_FAILURE`, error });
        dispatch({
          type: "ROUTING",
          data: { code: error.code || "ERROR", getState }
        });
      });
  }

  return next(action);
};
